// Flight-themed loading messages.
//
// These rotate into LoadingCircle on long waits (after the real contextual
// message has shown for a few seconds). Keep them clean and on-brand.
//
// PRUNE FREELY: delete any line you don't love. The grouping comments are just
// for browsing; everything here lands in one flat pool that gets shuffled.

export const FLIGHT_MESSAGES = [
  // Pre-flight & boarding
  'Stowing tray tables and crunching numbers ...',
  'Final boarding call for your report ...',

  // Climbing & cruising
  'Reaching cruising altitude ...',
  'Catching a tailwind ...',
  'Smooth air ahead, charts incoming ...',
  'Climbing for a better view of your data ...',
  'Cruising at 500 knots through your numbers ...',
  'The seatbelt sign is off, your data is still buckled up ...',

  // On-brand (CoPilot / Flight Plan)
  'Charting the fastest route to an A ...',
  'Plotting a course toward your accountability goals ...',
  'Adjusting altitude to hit your target rating ...',
  'Loading every campus onto the radar ...',
  'Triangulating your domains ...',

  // Reassuring (good for genuinely slow loads / turbulence)
  "Expect a little turbulence, we're loading a lot of data ...",
  "Hang tight, we're flying through some extra numbers ...",
  "A bit of headwind on this one, it's a big dataset ...",
  'Thanks for your patience, good data takes a few extra minutes ...',
  'Smoothing out some turbulence in the numbers ...',
  'Beginning our final descent ...',
  'Circling the runway, landing shortly ...',
  'Cleared for landing ...',
  'Wheels down in just a moment ...',
  'Connecting at the gate, please remain seated ...',

  // Cheeky / fun
  'Please keep your expectations in the upright and locked position ...',
  'The captain would like to thank you for your patience ...',
  'Look out the left window to watch your student achievement ...',
  'Our flight attendants are passing out fresh charts ...',
  'Securing all loose data in the overhead bins ...',
  'Your numbers are now free to move about the cabin ...',
  'The fasten-your-data sign is now on ...',
  'We know you have your choice of data tools, thanks for flying CoPilot ...',
  'Tightening the seatbelt around some big numbers ...',
  'Locating the nearest A rating (it may be behind you) ...',
  'Please direct your attention to the charts now loading ...',
  "We've dimmed the cabin lights so the data can shine ...",
  "Sit tight, the view's worth it ...",
];

export default FLIGHT_MESSAGES;
